import Api from '@/services/Api'

export default {
  getCategories () {
    return Api().get('/api/v1/categories')
  },

  addCategory (params) {
    return Api().post('/api/v1/categories', params, {
      withCredentials: true
    })
  },

  updateCategory (params) {
    return Api().put(`/api/v1/categories/${params._id}`, params, {
      withCredentials: true
    })
  },

  getCategory (id) {
    return Api().get(`/api/v1/categories/${id}`)
  },

  deleteCategory (id) {
    return Api().delete(`/api/v1/categories/${id}`, {
      withCredentials: true
    })
  }
}
